module.exports = __webpack_public_path__ + "media/images/country_flags/gg-bf0386049e2288419b1e1391c061e37b.png";